import * as types from 'containers/csboard/ActionType';
import { createAction } from 'redux-actions';

export const ANOUN_LIST_REQUEST = createAction(types.ANOUN_LIST_REQUEST);
export const ANOUN_LIST_SUCCESS = createAction(types.ANOUN_LIST_SUCCESS);
export const ANOUN_LIST_FAILURE = createAction(types.ANOUN_LIST_FAILURE);

export const ANOUN_DETAILED_REQUEST = createAction(types.ANOUN_DETAILED_REQUEST);
export const ANOUN_DETAILED_SUCCESS = createAction(types.ANOUN_DETAILED_SUCCESS);
export const ANOUN_DETAILED_FAILURE = createAction(types.ANOUN_DETAILED_FAILURE);

export const FAQ_LIST_REQUEST = createAction(types.FAQ_LIST_REQUEST);
export const FAQ_LIST_SUCCESS = createAction(types.FAQ_LIST_SUCCESS);
export const FAQ_LIST_FAILURE = createAction(types.FAQ_LIST_FAILURE);

export const MTRL_FILE_REQUEST = createAction(types.MTRL_FILE_REQUEST);
export const MTRL_FILE_SUCCESS = createAction(types.MTRL_FILE_SUCCESS);
export const MTRL_FILE_FAILURE = createAction(types.MTRL_FILE_FAILURE);

export const MTRL_CONDITION_REQUEST = createAction(types.MTRL_CONDITION_REQUEST);
export const MTRL_CONDITION_SUCCESS = createAction(types.MTRL_CONDITION_SUCCESS);
export const MTRL_CONDITION_FAILURE = createAction(types.MTRL_CONDITION_FAILURE);

export const MTRL_LIST_REQUEST = createAction(types.MTRL_LIST_REQUEST);
export const MTRL_LIST_SUCCESS = createAction(types.MTRL_LIST_SUCCESS);
export const MTRL_LIST_FAILURE = createAction(types.MTRL_LIST_FAILURE);

export const TERMS_CONDITIONS_REQUEST = createAction(types.TERMS_CONDITIONS_REQUEST);
export const TERMS_CONDITIONS_SUCCESS = createAction(types.TERMS_CONDITIONS_SUCCESS);
export const TERMS_CONDITIONS_FAILURE = createAction(types.TERMS_CONDITIONS_FAILURE);

export const NIMPT_ANOUNALL_REQUEST = createAction(types.NIMPT_ANOUNALL_REQUEST);
export const NIMPT_ANOUNALL_SUCCESS = createAction(types.NIMPT_ANOUNALL_SUCCESS);
export const NIMPT_ANOUNALL_FAILURE = createAction(types.NIMPT_ANOUNALL_FAILURE);

export const GO_ANOUN_LIST = createAction(types.GO_ANOUN_LIST);

export const ANOUN_ARRAY_PASS = createAction(types.ANOUN_ARRAY_PASS);

export const SET_PAGE_RELOAD = createAction(types.SET_PAGE_RELOAD);

